import * as S from './styles'

export interface RoundImageProps {
  image: string
}

export const RoundImage = ({ image }: RoundImageProps) => {
  return <S.Wrapper image={image} />
}
